import type { RootState } from 'src/redux/store'

export const selectUserSavedCards = (
  state: RootState
): {
  data: UserSavedCreditCard
} => state['@user'].savedCards

export const selectUser = (state: RootState) => state['@user'].user
